import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import colors from 'common/styles/colors';
import { FlexContainer } from 'common/components/atoms';
import { formatDate } from 'common/utils';
import MetadataContainer from 'common/components/atoms/MetadataContainer';
import DeleteIconSvg from 'common/images/BearingModal/DeleteIconSvg';
import NoteSvgNew from 'common/images/NoteSvgNew';
import { deleteNote } from 'home/Activity/actions/activity.actions';

import {
  TimelineNoDataContainer as NoDataContainer,
  TimelineItemContainer as TaskItemContainer,
  TimelineText as Text,
  TimelineSecondaryText as SecondaryText,
  TimelineIconContainer as IconContainer
} from './TaskDetailsModal.styled';

function NotesTimeline({ notes, taskId, setNoteModalOpen, deleteNote }) {
  const { t } = useTranslation();
  const getNoteTimestamp = (note) => {
    if (note.created_at) return note.created_at;
    if (note.updated_at) return note.updated_at;
    if (note.timestamp) return note.timestamp;
    return note.id || 0;
  };

  const sortedNotes = _.orderBy(
    notes || [],
    [getNoteTimestamp],
    ['desc']
  );

  return (
    <div style={{ marginTop: '1rem' }}>
      {_.isEmpty(sortedNotes) ? (
        <NoDataContainer>{t('taskDetailsModal.timeline.noNotes')}</NoDataContainer>
      ) : (
        sortedNotes.map(note => (
          <TaskItemContainer
            key={note.id}
            onClick={() => setNoteModalOpen(note.id)}
          >
            <IconContainer>
              <NoteSvgNew />
            </IconContainer>
            <FlexContainer direction="column" flexGrow={1}>
              <Text color={colors.black}>
                {note.note_text || t('taskDetailsModal.timeline.noNoteText')}
              </Text>
              <MetadataContainer fontSize="12px">
                <SecondaryText>{formatDate(getNoteTimestamp(note))}</SecondaryText>
              </MetadataContainer>
            </FlexContainer>
            <IconContainer
              onClick={(e) => {
                e.stopPropagation();
                deleteNote(note.id, taskId);
              }}
              title={t('taskDetailsModal.timeline.deleteNote')}
            >
              <DeleteIconSvg />
            </IconContainer>
          </TaskItemContainer>
        ))
      )}
    </div>
  );
}

NotesTimeline.propTypes = {
  notes: PropTypes.array,
  taskId: PropTypes.number.isRequired,
  setNoteModalOpen: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired
};

NotesTimeline.defaultProps = {
  notes: []
};

const mapDispatchToProps = dispatch => ({
  deleteNote: bindActionCreators(deleteNote, dispatch)
});

export default connect(null, mapDispatchToProps)(NotesTimeline);
